/**
 * Global helper for opening the platform-specific
 * "Notifications are blocked" instructions dialog.
 *
 * Replaces generic "enable in your browser settings" toasts so we
 * can give users exact step-by-step instructions for their OS/browser.
 */

export const NOTIFICATION_BLOCKED_EVENT = 'lupuslogix:notifications-blocked';

/**
 * Dispatches a window event the global <NotificationBlockedDialog />
 * listens for. Safe to call from anywhere (including non-React code).
 */
export function openNotificationBlockedDialog(): void {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new CustomEvent(NOTIFICATION_BLOCKED_EVENT));
  } catch {
    // No-op: environments without CustomEvent shouldn't crash callers.
  }
}

/**
 * Returns true if the browser/OS is currently reporting that
 * notifications have been denied for this origin.
 */
export function isNotificationPermissionDenied(): boolean {
  if (typeof window === 'undefined') return false;
  if (!('Notification' in window)) return false;
  try {
    return Notification.permission === 'denied';
  } catch {
    return false;
  }
}
